export function getInputId(fieldId) {
  return "form-field-input-" + fieldId;
}
export function getLabelId(fieldId) {
  return "form-field-label-" + fieldId;
}
export function getDescriptionId(fieldId) {
  return "form-field-description-" + fieldId;
}
export function getErrorId(fieldId) {
  return "form-field-error-" + fieldId;
}
export function getAriaDescribedBy(errorId, descriptionId) {
  return errorId + " " + descriptionId;
}
//# sourceMappingURL=field-attributes.js.map